import { render } from "./MomoForm.vue?vue&type=template&id=2b55056b&scoped=true&ts=true"
import script from "./MomoForm.vue?vue&type=script&lang=ts"
export * from "./MomoForm.vue?vue&type=script&lang=ts"

import "./MomoForm.vue?vue&type=style&index=0&id=2b55056b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b55056b"],['__file',"src/components/payoutAccounts/MomoForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b55056b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b55056b', __exports__)) {
    api.reload('2b55056b', __exports__)
  }
  
  module.hot.accept("./MomoForm.vue?vue&type=template&id=2b55056b&scoped=true&ts=true", () => {
    api.rerender('2b55056b', render)
  })

}


export default __exports__